import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent implements OnInit {

  showSuccess: boolean = false;
  showError: boolean = false;
  successMsg = ''
  errorMsg = ''
  orderDetails: any
  orderID: any

  constructor(private url: ActivatedRoute,private router: Router,private api: ApiService) { }

  ngOnInit(): void {
    if(this.url.snapshot.params['orderID']){
      this.orderID = this.url.snapshot.params['orderID'];
    }
    console.log(this.orderID)
    if(this.orderID){
      this.api.orderDetails(this.orderID).subscribe({
        next: (response) => {
          this.orderDetails = response.data.OrderDetails
          console.log(response.data.OrderDetails)
        }, error: (error: HttpErrorResponse) => {
          this.showError = true
          this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
          setTimeout(() => {
            this.showError = false
            this.errorMsg = ''
          }, 3000);
        }
      })
    }
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = './assets/img/logo.ico';
  }
  
  goBack(){
    history.back()
  }
}
